import styled from "styled-components/native";

const StyledTextInput = styled.TextInput.attrs({
  underlineColorAndroid: "transparent",
})<{ isFocused?: boolean }>`
    border: 1px solid ${(props) => props.isFocused ? "#1677FF" : "#C5CDD8"};
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
    margin-bottom: 24px;
    color: #101928;
    background-color: #fff;
    elevation: 0;
`;

export default StyledTextInput;